// extracted by mini-css-extract-plugin
module.exports = {"ImageGallery":"ImgGallery_ImageGallery__2CN5G"};